import { useContext } from "react";
import { ProtectContext } from "../../context/protect_context";
import { Resource } from "../common/Resource";
import { useLocation } from "react-router-dom";

export const Footer = () => {
  const { data } = useContext(ProtectContext);
  const location = useLocation();
  if (!data?.footer) return null;
  return (
    <footer>
      {!location.pathname.startsWith("/news") && <Resource />}

      <div className="mx-auto w-full max-w-7xl px-4 py-14 text-center lg:px-8">
        <div className="grid gap-10 text-left md:grid-cols-3">
          <div>
            <h4 className="text-lg font-semibold text-gray-900">Хаяг</h4>
            <address className="mt-3 not-italic text-sm text-gray-600">
              {data?.footer?.address}
            </address>
          </div>
          <div>
            <h4 className="text-lg font-semibold text-gray-900">Утас</h4>
            <p className="mt-3 text-sm text-gray-600">{data?.footer?.phone}</p>
          </div>
          <div>
            <h4 className="text-lg font-semibold text-gray-900">Имэйл</h4>
            <a
              href={`mailto:${data?.footer?.email}`}
              className="mt-3 block text-sm text-red-500"
            >
              {data?.footer?.email}
            </a>
          </div>
        </div>
        <div className="mt-10 space-y-2 text-sm text-gray-500">
          <p>{data?.footer?.copyright}</p>
        </div>

        <p className="text-gray-500 mt-4">{data?.footer?.by}</p>
      </div>
    </footer>
  );
};
